export type messageBoxButtons = "ok" | "okCancel" | "yesNo" | "yesNoCancel"; 
export type messageBoxIcon = "info" | "warning" | "error" | "success" | "none";
export const messageBoxResult= {
    ok: "ok",
    cancel: "cancel",
    yes: "yes",
    no: "no"
}